import { InjectionToken } from '@angular/core';
import { IWhiteLabel } from './white-label.interface';

export const WHITE_LABEL_TOKEN = new InjectionToken<IWhiteLabel>('WHITE_LABEL_TOKEN');
